const companyHeaders = [
    {
      id: "cuit",
      numeric: false,
      disablePadding: false,
      label: "CUIT",
    },
    {
      id: "legalName",
      numeric: false,
      disablePadding: false,
      label: "NOMBRE",
    },
    {
      id: "state",
      numeric: false,
      disablePadding: false,
      label: "ESTADO",
    },
    {
      id: "contractStartDate",
      numeric: false,
      disablePadding: false,
      label: "INICIO CONTRATO",
    },
    {
      id: "contractEndDate",
      numeric: false,
      disablePadding: false,
      label: "FINAL CONTRATO",
    },
  ];

  export default companyHeaders